import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageBodies } from '../voyageBodies-sidecar'
import { voyageBodiesData } from '../voyageBodiesData-sidecar'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageCrewStyle {
  crewId: number
  hair: number
  hairColor: number
  body: number
  bodyColor: number
  head: number
  headColor: number
}

export const voyageMessageId = EVoyageMessage.CrewStyle

export function write(m: IMessageWriter, d: IMessageCrewStyle) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write32(m, d.crewId)
  messageWriter.write32(m, d.hair)
  messageWriter.write32(m, d.hairColor)
  messageWriter.write32(m, d.body)
  messageWriter.write32(m, d.bodyColor)
  messageWriter.write32(m, d.head)
  messageWriter.write32(m, d.headColor)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageCrewStyle = {
    crewId: messageWriter.read32(m),
    hair: messageWriter.read32(m),
    hairColor: messageWriter.read32(m),
    body: messageWriter.read32(m),
    bodyColor: messageWriter.read32(m),
    head: messageWriter.read32(m),
    headColor: messageWriter.read32(m),
  }

  return d
}

export function test() {
  let ex: IMessageCrewStyle = {
    crewId: 100,
    hair: 123,
    hairColor: 0x123456,
    body: 34,
    bodyColor: 0x323345,
    head: 2,
    headColor: 0x243421,
  }
  messageWriter.test('crew-style', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)
  let cr = voyageCrew.findById(msg.crewId)

  if (cr && cr.crewState && cr.crewState.body) {
    let b = cr.crewState.body
    voyageBodies.setBody(b, voyageBodiesData.bodies[msg.body])
    b.imageBody.tint = msg.bodyColor
    voyageBodies.setHair(b, voyageBodiesData.hairs[msg.hair])
    b.imageHair.tint = msg.hairColor
    voyageBodies.setHead(b, voyageBodiesData.heads[msg.head])
    b.imageHead.tint = msg.headColor
  }
}

export function sendMessageAndImmediatelyExecute(msg: IMessageCrewStyle) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
